import React from 'react';
import PropTypes from 'prop-types';

const Spinner = (props) => {
  let cssClass = '';
  const { hidden } = props;

  if (props === undefined) {
    cssClass = '';
  } else if (hidden) {
    cssClass = 'd-none';
  }

  return (
    <div className="d-flex justify-content-center mt-2">
      <div className={`spinner-border ${cssClass}`} role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

Spinner.propTypes = {
  hidden: PropTypes.bool,
};

Spinner.defaultProps = {
  hidden: false,
};

export default Spinner;
